
        <!-- 交易流水 -->
<template>
  <!-- <vue-scroll :ops="ops" style="width:100%;min-height:95%;"> -->
  <div class="financeSetA">
    <div class="navCalss">| 发货单管理</div>

    <div class="monewt" style="min-width: 1000px">
      <el-form :inline="true">
        <div style="margin: 10px 0">
          <div class="wj_flex">
            <div class="wj_left">
              <el-form-item label="客户:">
                <el-input
                  clearable
                  v-model="vipCode"
                  @input="vipCodeBlur"
                  style="width: 138px"
                  placeholder="输入客户VIP号查询"
                ></el-input>
              </el-form-item>
            </div>
            <div class="wj_left">
              <el-form-item label="发货编号:">
                <el-input
                  clearable
                  @input="sendNoBlur"
                  v-model="sendNo"
                  style="width: 160px"
                  placeholder="输入发货编号查询"
                ></el-input>
              </el-form-item>
            </div>
            <div class="wj_left">
              <el-form-item label="出库时间：">
                <el-date-picker
                  v-model="chukuTime"
                  type="daterange"
                  @change="getDate(chukuTime)"
                  range-separator="至"
                  clearable
                  style="width: 220px; padding-right: 6px"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item>
            </div>

            <div class="wj_left">
              <span>签收状态：</span>
              <el-select
                v-model="checkedRecStatus"
                clearable
                @change="getStoreList('1')"
                placeholder="请选择"
                style="width: 120px"
              >
                <el-option
                  v-for="item in receOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </el-form>
      <div>
        <span>批次：</span>
        <el-select
          v-model="batchNum"
          style="width: 255px; padding-right: 6px"
          remote
          @change="batchChange"
          @clear="clearChecked"
          :remote-method="remoteMethod"
          reserve-keyword
          filterable
          :loading="loading"
          clearable
          placeholder="请输入批次"
        >
          <el-option
            v-for="item in batchList"
            :key="item.sendId"
            :label="item.remark"
            :value="item.remark"
          >
          </el-option>
        </el-select>
        <span>派送点：</span>
        <el-select
                  v-model="deliverAddress"
                  style="width: 160px"
                  clearable
                  :disabled="roleId==3"
                >
                  <el-option label="所有" value=""></el-option>
                  <el-option
                    v-for="(addressObj, aIndex) in deliverAddressArr"
                    :key="aIndex"
                    :label="addressObj.deliveryTitle"
                    :value="addressObj.adminId"
                  ></el-option>
                </el-select>
        <el-button
          style="margin-left: 20px"
          @click="getStoreList('1')"
          type="primary"
          >查询</el-button
        >
        <el-button
          style="margin-left: 6px"
          type="primary"
          @click="exportToExcel()"
        >
          批量导出Excel
        </el-button>

        <!-- <button class="totalFeeBtn">
          <div class="totalFee">
            实收总费用:<span>{{ totalFee }}</span>
          </div>
        </button> -->
      </div>
    </div>
    <br />
    <!-- //表格 -->
    <div class="table_container">
      <el-table :data="orderList" border style="width: 100%" stripe>
        <el-table-column
          label="发货编号"
          prop="sendNo"
          min-width="220px"
          align="center"
        >
        <template slot-scope="scope">
            <span
              class="boxTag"
              v-if="scope.row.isDelivery"
            >
              {{ scope.row.isDelivery ? "派" : "" }}
            </span>
            {{ scope.row.sendNo }}
           
          </template>
        </el-table-column>

        <el-table-column
          label="发货单生成时间"
          prop="sendTime"
          min-width="120px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="VIP号"
          prop="vipCode"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="用户名"
          prop="realName"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="订单数量"
          prop="orderCount"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="实收费用 CAD"
          prop="amount"
          min-width="120px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="余额"
          width="120px"
          align="center"
          prop="userBalance"
        >
        </el-table-column>
        <!-- <el-table-column
          label="混箱数"
          prop="mixingTank"
          min-width="100px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="箱数"
          prop="unMixingTank"
          min-width="100px"
          align="center"
        >
        </el-table-column> -->

        <el-table-column
          label="批次"
          prop="remark"
          min-width="180px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="出库时间"
          prop="createTime"
          min-width="150px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="签收状态"
          prop="isReceipt"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.isReceipt ? "已签收" : "未签收" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="operation"
          align="center"
          label="操作"
          fixed="right"
          min-width="100px"
        >
          <template slot-scope="scope">
            <div style="display: flex">
              <div style="flex: 6">
                <el-button type="text" @click="onLook(scope.row)"
                  >查看</el-button
                >
              </div>

              <div style="flex: 6">
                <el-button type="text" @click="onTOEcexlce(scope.row)"
                  ><span style="color: red">导出</span></el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :page-sizes="paginations.page_sizes"
          :page-size="paginations.page_size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page="paginations.page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="dialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="840px"
      center
    >
      <div style="position: relative">
        <el-table
          :show-header="false"
          :data="tableData"
          border
          style="width: 100%"
          stripe
        >
          <el-table-column
            prop="index"
            label="序号"
            align="center"
            min-width="100px"
          >
          </el-table-column>
          <el-table-column
            label="订单名"
            prop="productName"
            min-width="150px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="运单号"
            prop="expressNo"
            min-width="150px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="箱号"
            prop="boxNumber"
            min-width="150px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="体积 CBM"
            prop="productSize"
            min-width="90px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="重量 KG"
            prop="productWeight"
            min-width="80px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="折扣率 %"
            prop="rate"
            min-width="80px"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.rate !== true">{{ scope.row.rate }}</span>
              <!-- <el-button type="text" v-if="scope.row.rate==true">修改</el-button> -->
            </template>
          </el-table-column>
          <el-table-column
            label="费用 CAD"
            prop="predictTotal"
            min-width="120px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="余额"
            prop="userBalance"
            min-width="80px"
            align="center"
          >
          
          </el-table-column>
          <el-table-column
            label="订单备注"
            prop="remark"
            min-width="220px"
            align="center"
          >
          </el-table-column>
        </el-table>

        <div
          style="position: absolute; right: 33px; top: -46px"
          v-if="lookingStatus !== 4 && lookingStatus < 11 && isCouldUpdated"
        >
          <el-button type="primary" @click="updateExtraFee"
            >修改额外费用</el-button
          >
        </div>
        
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="isUpdateFeeShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="30%"
    >
      <div style="margin-top: -30px">
        <h1 style="float: left; font-size: 18px">额外费用 :</h1>
        <el-input
          v-model="feeInput"
          placeholder="请输入修改后的费用"
          autofocus
          style="float: left; width: 200px; margin: -8px 0 20px 20px"
        ></el-input>
        <h1
          style="
            clear: both;
            float: left;
            padding-bottom: 10px;
            font-size: 18px;
          "
        >
          备注 :
        </h1>
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="textarea"
          maxlength="300"
          show-word-limit
          clearable
          resize="none"
          rows="8"
        >
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeUpdateDialog">取 消</el-button>
        <el-button type="primary" @click="certainUpdateDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  <!-- </vue-scroll> -->
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as order from "@/api/order";
import Draggable from "vuedraggable";
import Sortable from "sortablejs";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { axios } from "utils/";
import * as book from "../../api/book";
export default {
  components: {
    Draggable,
  },
  data() {
    let dataValidate = (rule, value, callback) => {
      let that = this;
      if (value === "") {
        let text;
        if (rule.field == "bankCard") {
          text = "银行卡号";
        } else if (rule.field == "bankUser") {
          text = "账户名";
        } else if (rule.field == "bankName") {
          text = "开户行";
        } else if (rule.field == "salePrice") {
          text = "商品现价";
        } else if (rule.field == "stock") {
          text = "商品库存";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    return {
      vipCode: "",
      newDate: "",
      // deliveryDate:"",
      orderG: "",
      volumeTotal: 0,
      weightTotal: 0,
      toEcelce: false,
      orderTitle: "",
      remark: "",
      batchNum: "",
      // 派送点
      deliverAddress: null,
      deliverAddressArr: [],
      value1: "",
      activeName: "first",
      columns: [
        { title: "商品名称", key: "orderNo" },
        { title: "数量", key: "productNum" },
        { title: "库位", key: "shelves" },
        { title: "入库时间", key: "storeTime" },
        { title: "关联运单号", key: "expressNo" },
        { title: "关联订单编号", key: "orderNo" },
        { title: "客户", key: "userName" },
        { title: "客户VIP号", key: "vipCode" },
      ],
      //现在时间
      NowDate: "",
      dialog: {
        show: false,
      },

      orderNOA: "",

      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      orderList: [],
      orderListExport: [],
      tableData: [
        {
          remark: "sdad",
          predictTotal: "100",
          rate: 10,
          productWeight: 12,
        },
      ],

      howManyTotal: 0,
      listArr: [],
      columnsOrder: [
        { title: "发货编号", key: "sendNo" },
        { title: "发货时间", key: "sendTime" },
        { title: "发货VIP号", key: "vipCode" },
        { title: "用户名", key: "realName" },
        { title: "订单数量", key: "orderCount" },
        { title: "实收费用CAD", key: "amount" },
        { title: "余额", key: "userBalance" },
        { title: "批次", key: "remark" },
        { title: "操作时间", key: "operatorTime" },
      ],

      isUpdateFeeShow: false,
      feeInput: "",
      textarea: "",

      paramSendId: "",
      lookWhichRow: null,
      chukuTime: null,
      startDate: null,
      endDate: null,
      totalFee: "",
      lookingStatus: null,
      sendNo: null,
      // 批次列表
      batchList: [],
      // 批次的时间 节流
      timeout: null,
      // 已选签收状态
      checkedRecStatus: null,
      // 签收状态选项
      receOptions: [
        { value: "0", label: "未签收" },
        { value: "1", label: "已签收" },
      ],
      loading: false,
      // 详情里展示的余额
      detailBalance:0,
      // 是否可以修改额外费用
      isCouldUpdated:true,
      // 表示当前登录账号类型
      roleId:null,
    };
  },
  created() {
    let that = this;
    that.getStoreList();
    this.getBatchList();
    this.getAdressId();
  },
  mounted(){
    let userinfo=mUtils.getStore('userinfo');
    
    if(userinfo.roleId == 3){
      this.roleId = 3;
      this.deliverAddress = userinfo.adminId;
      
    }
    
  },
  methods: {
    //获取详情
    //获取详情
    getPreviewOrders(val) {
      let that = this;

      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      let data = {
        sendId: val.sendId,
        userId: val.userId,
      };
      let standard = 0,
        countTotal = 0,
        orderName = "";

      // order.sendSerOrders(data).then((res) => {

      order.getSendOrderInfo(data).then((res) => {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list.length) {
            that.volumeTotal = 0;
            that.weightTotal = 0;
            res.data.data.list.forEach(function (value, i) {
              value.index = i + 1;
              that.volumeTotal = value.productSize - 0 + that.volumeTotal;
              that.weightTotal = value.productWeight - 0 + that.weightTotal;
              value.detailList.forEach(function (valueB, index) {});
              standard = mUtils.accAdd(standard, value.total);
              countTotal = mUtils.accAdd(countTotal, value.demandMoney);
              value.predictTotal = value.total;
              if (value.detailList.length > 1) {
                if (value.detailList[0].productName <= 5) {
                  value.productName =
                    value.detailList[0].productName +
                    "...等" +
                    value.detailList.length +
                    "款";
                } else {
                  value.productName =
                    value.detailList[0].productName.substring(0, 5) +
                    "...等" +
                    value.detailList.length +
                    "款";
                }
              } else {
                if (value.detailList[0].productName <= 5) {
                  value.productName =
                    value.detailList[0].productName +
                    "...等" +
                    value.detailList.length +
                    "款";
                } else {
                  value.productName =
                    value.detailList[0].productName.substring(0, 5) +
                    "...等" +
                    value.detailList.length +
                    "款";
                }
              }
            });
          }

          if(res.data.data && res.data.data.sendPojo && res.data.data.sendPojo.extraType == 1){
            this.isCouldUpdated = false;
          }else{
            this.isCouldUpdated = true;
          }
          let obj = {};
          let arr = [];
          // orderName=res.data.data.vipCode+"-"+mUtils.formatDate( new Date(res.data.data.sendTime)).substring(0,10)
          obj.index = "VIP号：";
          if (res.data.data && res.data.data.vipCode) {
            obj.productName = res.data.data.vipCode;
          } else {
            obj.productName = "";
          }
          obj.expressNo = "客户：";
          obj.productSize = res.data.data.realName;
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = "#";
          obj.productName = "订单名";
          obj.expressNo = "运单号";
          obj.boxNumber = "箱号";
          obj.productSize = "体积 CBM";
          obj.productWeight = "重量 KG ";
          obj.rate = " 折扣率 %";
          obj.predictTotal = "费用 CAD ";
          obj.userBalance = "余额"
          obj.remark = "订单备注";
          arr.push(obj);
          

          res.data.data.list = arr.concat(res.data.data.list);
          arr = [];
          obj = {};
          obj.index = "总";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productSize = that.volumeTotal;
          obj.productWeight = that.weightTotal;
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productSize = "";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "标准费用";
          obj.remark = standard ? standard.toFixed(2) : 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "工单费用";
          obj.remark = res.data.data.demandMoney || "0";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = true;
          obj.predictTotal = "额外费用";
          obj.remark = res.data.data.sendPojo.extraPrice || "0";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "额外费用备注";
          obj.remark = res.data.data.sendPojo.extraPriceRemark || "";
          that.feeInput = res.data.data.sendPojo.extraPrice || 0;
          that.textarea = res.data.data.sendPojo.extraPriceRemark || "";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "发货单总费用";

          let newAmount = res.data.data.sendPojo.amount;
          obj.remark = newAmount ? newAmount.toFixed(2) : 0;
          arr.push(obj);

          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          obj = {};
          obj.index = "混箱数";
          obj.productName = res.data.data.mixingTankCount;
          // obj.productName = that.lookWhichRow.mixingTank;

          const MixTank = res.data.data.mixingTank;
          // let mixBoxNumberStr = "";
          // if (MixTank.length > 0) {
          //   MixTank.forEach((tank, index) => {
          //     mixBoxNumberStr += " " + tank.boxNumber;
          //   });
          // }

          // obj.expressNo = mixBoxNumberStr;
          obj.productVolume = " 123";
          obj.productSize = "";
          obj.productWeight = "";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          that.paramSendId = res.data.data.sendPojo.sendId;

          obj = {};
          obj.index = "箱数";
          obj.productName = res.data.data.unMixingTanksCount;
          // obj.productName = that.lookWhichRow.unMixingTank;

          // const unMixTank = res.data.data.unMixingTanks;
          // let unBoxNumberStr = "";
          // unMixTank.forEach((unTank, index) => {
          //   unBoxNumberStr += " " + unTank.boxNumber;
          // });

          // obj.expressNo = unBoxNumberStr;
          obj.productVolume = " ";
          obj.productSize = "";
          obj.productWeight = "";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          res.data.data.list = res.data.data.list.concat(arr);

          that.tableData = res.data.data.list;
          that.tableData.map((everyObj,eIndex)=>{
            if(eIndex == 2){
              everyObj.userBalance = this.detailBalance;
              return everyObj;
            }
          })
          
          if (that.toEcelce) {
            let columns = [
              { title: "#", key: "index" },
              { title: "订单名", key: "productName" },
              { title: "运单号", key: "expressNo" },
              { title: "箱号", key: "boxNumber" },
              { title: "体积 CBM", key: "productSize" },
              { title: "重量 KG ", key: "productWeight" },
              { title: "折扣率 %", key: "rate" },
              { title: "费用 CAD", key: "predictTotal" },
              { title: "余额", key: "userBalance" },
              { title: "订单备注", key: "remark" },
            ];

            mUtils.export2ExcelTitle(columns, that.tableData, that.orderTitle);
            that.toEcelce = false;
          }
        } else {
          that.$message.error("获取列表失败");
        }
        loading.close();
      });
    },
    //查看
    onLook(val) {
      let that = this;
      that.lookWhichRow = val;
      console.log(697, that.lookWhichRow);
      that.lookingStatus = that.lookWhichRow.status || null;
      if(val.userBalance !== undefined){
        this.detailBalance = val.userBalance;
      }else{
        this.detailBalance = "";
      }
      that.dialog.show = true;
      that.getPreviewOrders(val);
    },
    //导出
    onTOEcexlce(val) {
      let that = this;
      that.toEcelce = true;
      that.orderTitle = val.vipCode + "-" + val.sendTime;
      if(val.userBalance !== undefined){
        this.detailBalance = val.userBalance;
      }else{
        this.detailBalance = "";
      }
      that.getPreviewOrders(val);
    },
    //获取表格序号
    getIndex($index) {
      //表格序号
      return (
        (this.paginations.page_index - 1) * this.paginations.page_size +
        $index +
        1
      );
    },

    getStoreList(dataA) {
      let that = this;

      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      let data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        vipCode: that.vipCode ? that.vipCode : "",
        startDate: that.startDate ? that.startDate : "",
        endDate: that.endDate ? that.endDate : "",
        remark: that.remark ? that.remark : null,
        sendNo: that.sendNo ? that.sendNo : null,
        batchNumber: that.batchNum ? that.batchNum.trim() : null,
        isReceipt: that.checkedRecStatus || null,
        // deliveryId:that.deliverAddress || null,
        deliveryId:null,
      };

      // 如果选择了派送点或者已有派送点
      if(that.deliverAddress){
        that.deliverAddressArr.forEach((dItem,index)=>{
          if(dItem.adminId == that.deliverAddress){
            data.deliveryId = dItem.addressId;
          }
        })
      }

      dataA == "1" ? (data.pageIndex = 1) : "";
      dataA == "1" ? (that.paginations.page_index = 1) : "";

      order.sendOrderList(data).then((res) => {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, i) {
              if (val.user && val.user.vipCode) {
                val.vipCode = val.user.vipCode || "";
              } else {
                val.vipCode = "";
              }

              if (val.user && val.user.realName) {
                val.realName = val.user.realName || "";
              } else {
                val.realName = "";
              }
              val.createTime = mUtils
                .formatDate(new Date(val.createTime))
                .substring(0, 16);
              val.sendTime = mUtils
                .formatDate(new Date(val.sendTime))
                .substring(0, 10);
              val.operatorTime = mUtils
                .formatDate(new Date(val.operatorTime))
                .substring(0, 16);
            });
            that.orderList = res.data.data.list;
            that.orderList.map((newObj) => {
              if (newObj.user && newObj.user.balance !== undefined) {
                newObj.userBalance = newObj.user.balance || "0";
              } else {
                newObj.userBalance = "";
              }
            });
            that.paginations.total = res.data.data.pageCount;
            that.totalFee = res.data.data.total;
            that.howManyTotal = res.data.data.pageCount;
            // that.getAllData();
          } else {
            that.orderList = [];
            that.paginations.total = 0;
            that.totalFee = 0;
            that.howManyTotal = 0;
            // that.getAllData();
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询列表失败");
          } else {
            that.$message.error("获取列表失败");
          }
        }
        loading.close();
      });

      // that.getHowMangTotal();
    },

    outDepot() {
      this.getStoreList("1");
    },

    getDate(chukuTime) {
      if (!chukuTime) {
        this.startDate = "";
        this.endDate = "";
        this.getStoreList("1");
        return;
      }
      this.startDate = new Date(mUtils.formatDate(chukuTime[0])).getTime();
      let tempEndDate = new Date(mUtils.formatDate(chukuTime[1])).getTime();
      tempEndDate *= 1;
      tempEndDate += 86399000;
      this.endDate = tempEndDate;
      this.getStoreList("1");
    },

    sendNoBlur() {
      this.getStoreList("1");
    },
    vipCodeBlur() {
      this.getStoreList("1");
    },
    remarkBlur() {
      this.getStoreList("1");
    },

    // 批量导出发货单
    exportToExcel() {
      let that = this;
      // let orderName = "发货单Excel";
      that.getAllData();
      // mUtils.export2Excel(that.columnsOrder, that.listArr, orderName);
    },

    async getAllData() {
      let that = this;
      let data = {
        pageIndex: 1,
        pageSize: 400,
        vipCode: that.vipCode ? that.vipCode : "",
        startDate: that.startDate ? that.startDate : "",
        endDate: that.endDate ? that.endDate : "",
        remark: that.remark ? that.remark : null,
        sendNo: that.sendNo ? that.sendNo : null,
        batchNumber: that.batchNum ? that.batchNum.trim() : null,
        isReceipt: that.checkedRecStatus || null,
        // deliveryId:that.deliverAddress || null,
        deliveryId:null,
      };

      // 如果选择了派送点或者已有派送点
      if(that.deliverAddress){
        that.deliverAddressArr.forEach((dItem,index)=>{
          if(dItem.adminId == that.deliverAddress){
            data.deliveryId = dItem.addressId;
          }
        })
      }
      
      let howManyPage = Math.ceil((that.howManyTotal * 1) / 400);
      let listArr = [];
      for (let i = 1; i <= howManyPage; i++) {
        data.pageIndex = i;
        await order.sendOrderList(data).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.list) {
              res.data.data.list.map((every, index) => {
                every.sendTime = mUtils
                  .formatDate(new Date(every.sendTime))
                  .substring(0, 10);
                every.operatorTime = mUtils
                  .formatDate(new Date(every.operatorTime))
                  .substring(0, 16);
               if (every.user && every.user.vipCode) {
                  every.vipCode = every.user.vipCode;
                }
                if (every.user && every.user.realName) {
                  every.realName = every.user.realName;
                }

                listArr.push(every);
              });
            }
          }
        });
      }
      that.listArr = listArr;
      that.listArr.map((newObj) => {
        if (newObj.user && newObj.user.balance !== undefined) {
          newObj.userBalance = newObj.user.balance || "0";
        } else {
          newObj.userBalance = "";
        }
      });
      let orderName = "发货单Excel";
      mUtils.export2Excel(that.columnsOrder, that.listArr, orderName);
    },

    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;

      that.paginations.page_size = page_size;

      // 	if(that.searchData.keyWord){
      // that.getproductListLike()
      // 	}else{
      that.getStoreList();
      // }
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      // 		if(that.searchData.keyWord){
      // that.getproductListLike()
      // 	}else{
      that.getStoreList();
      // }
    },
    // },

    updateExtraFee() {
      let that = this;
      that.isUpdateFeeShow = true;
    },
    closeUpdateDialog() {
      let that = this;
      that.isUpdateFeeShow = false;
    },
    certainUpdateDialog() {
      let that = this;
      
      if (that.feeInput == "") {
        that.$message.warning("额外费用不能为空");
        return;
      }
      
      // if (parseFloat(that.feeInput*1) == 0) {
      //   that.$message.warning("额外费用不能为0");
      //   return;
      // }
      // if (that.feeInput*1 < 0) {
      //   that.$message.warning("额外费用不能小于0");
      //   return;
      // }
      console.log(1073,typeof(that.feeInput))
      if(that.feeInput){
        that.feeInput += "";
      }
      let param = {
        sendId: that.paramSendId,
        extraPrice: that.feeInput?that.feeInput.trim():"0",
        extraPriceRemark: that.textarea,
      };
      order.updateExtraInfo(param).then((res) => {
        if (res.data.code === 0) {
          that.$message.success("修改成功");
          that.getPreviewOrders(this.lookWhichRow);
          that.getStoreList();
        } else {
          that.$message.error("修改失败");
        }
        that.isUpdateFeeShow = false;
        that.feeInput = "";
        that.textarea = "";
      });
    },

    // 获取批次列表
    getBatchList(value) {
      let that = this;

      let data = {};

      value ? (data.batchNumber = value) : "";

      order.getSelectBatchList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },

    // 清除所选批次
    clearChecked() {
      this.getBatchList();
      this.getStoreList("1");
    },

    batchChange() {
      this.getStoreList("1");
    },

    // 远程搜索批次
    remoteMethod(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getBatchList(value);
      }, 500);
    },

    // 余额展示
    banlanceShow(row) {
      if (row.user && row.user.balance !== undefined) {
        return row.user.balance;
      }
    },

        //获取派送点
    getAdressId() {
      let uselist = mUtils.getStore("userinfo");
      let realName = uselist.realName;
      let roleId = uselist.roleId;
      book.deliveryList({ type: 2 }).then((res) => {
        if (res.status !== 200) {
          return this.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return this.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          this.deliverAddressArr = res.data.data.list;
        }
      });
    },

  },
};
</script>
<style  lang="less" scoped>
.financeSetA {
  margin: 20px 50px 100px 50px;

  .monewt {
    margin: 30px 0px 20px 0;
    // border: 1px solid rgba(121, 121, 121, 1);
    min-height: 50px;
    min-width: 900px;
  }
}
.pagination {
  margin: 20px 0;
}
.backakdia {
  background: #dcdfe6;
  line-height: 30px;
  min-height: 30px;
}
.ss {
  cursor: pointer;
  color: #409eff;
}
.navCal {
  margin: 20px 0;
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.ellipsis {
  // max-width: 150px;
  max-height: 20px;
  //  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.ellipsisB {
  max-width: 225px;
  max-height: 20px;
  //  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.wel-flex {
  display: flex;
  justify-content: left;
  align-items: center;
  margin: 10px 0;
}
.wrl-hedaNa {
  margin: 10px 0;
}
.wrl-productList {
  margin: 20px 0;
}
.wrl-border {
  height: 2px;
  margin: 20px 0;
  background-color: #d7d7d7;
}
.wrl-marign {
  margin: 0 30px;
}
.wrl-flex2 {
  display: flex;
  // margin:10px 0 ;
  justify-content: start;
  align-items: center;
  .wrl-felx4 {
    width: 700px;
  }
  .wrl-felx5 {
    max-width: 700px;
  }
  .wrl-felx6 {
    margin-left: 10px;
  }
}
.wrl-felxz {
  margin: 10px 30px;
  display: flex;
  justify-content: space-between;

  .wrl-left {
    flex: 1;
    .wrl-felxz1 {
      display: flex;
    }
  }
}
.backgroundA {
  background-image: url("../../assets/img/u69.svg");
  min-height: 80px;
  line-height: 80px;
  margin: 24% 30%;
  color: white;
  background-repeat: no-repeat;
}
.avatar {
  min-height: 80px;
  width: 80px;
}
.wlr-header {
  display: flex;

  .wlr-start {
    display: flex;
    justify-content: start;
  }
}
.inpoutTop {
  margin-top: 5px;
}
.space {
  margin: 0 5px;
}

.cursor {
  cursor: pointer;
}
.wj_flex {
  display: flex;
  justify-content: start;
}
.wj_left {
  text-align: left;
}
.totalFeeBtn {
  margin-left: 10px;
  background-color: transparent;
  .totalFee > span {
    display: inline-block;
    margin-left: 4px;
    color: green;
    font-weight: bold;
  }
}

.boxTag {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 4px;
  background-color: #ffa500;
  border-color: #faecd8;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// dispatchList.vue?1b7f529c